<script setup>
defineProps({
    content: String,
})
</script>

<template>
    <Head title="Cookies">
        <meta
            name="description"
            content="Zásady používání cookies na webu Kalianko. Informace o tom, jaké soubory cookies používáme a jak je spravovat."
        />
    </Head>

    <!-- Hero Section -->
    <section class="relative isolate overflow-hidden bg-gray-900 py-16 sm:py-24">
        <div
            class="from-brand-primary/20 absolute inset-0 -z-10 bg-linear-to-br to-transparent"
        />
        <div class="section-width relative px-2 lg:px-0">
            <div class="mx-auto max-w-2xl text-center">
                <h1 class="heading-1 text-white">Zásady používání cookies</h1>
                <p class="mt-4 text-lg/8 text-gray-300">
                    Informace o tom, jaké soubory cookies používáme a jak je můžete spravovat.
                </p>
            </div>
        </div>
    </section>

    <!-- Content Section -->
    <section class="section-width px-2 py-16 sm:py-24 lg:px-0">
        <div
            class="markdown-content mx-auto rounded-2xl border border-gray-200 bg-white p-6 shadow-sm sm:p-10"
            v-html="content"
        />
    </section>
</template>
